import React from 'react';

export const LazyProjectInformationPage = React.lazy(() => import('./ProjectInformation'));
